import { gql } from '@provision/graphql-client';
import { BRAND_FIELDS } from 'src/graphql/entities/brand';
import { CLIENT_FIELDS } from 'src/graphql/entities/client';
import { CLIENT_EMAIL_FIELDS } from 'src/graphql/entities/client-email';
import { CLIENT_PHONE_FIELDS } from 'src/graphql/entities/client-phone';
import { META_DATA_SEARCH_QUERY_FIELDS } from 'src/graphql/entities/metadata.fragments';
import { PARTNER_FIELDS, PARTNER_RELATIONS } from 'src/graphql/entities/partner';
import { PLATFORM_FIELDS } from 'src/graphql/entities/platform-user';
import { PRE_SOLD_MEMBERSHIP_FIELDS } from 'src/graphql/entities/pre-sold-membership/pre-sold-membership.fragments';
import { PROJECT_FIELDS } from 'src/graphql/entities/project/project.fragments';

export const ADDRESS_SUMMARY_FIELDS = gql`
  fragment AddressSummaryFields on Address {
    id
    addressId
    partnerId
    primaryClientId
    primaryProjectId
    address1
    address2
    city
    state
    zip
    clientActivatedMembership
    platformSlaId
    clientSelectedMembership
    businessName
    brandId
    orgNotes
    ownerId
    cppExpDate
    creditCardProvided
    chargifySubId
    tosAccepted
    membershipSalesNotes
    rsmNotes
    isMonitored
    brand {
      id
      brandGroupId
      name
    }
    platformSla {
      id
      platformSlaId
      displayName
    }
    platformUser {
      id
      firstName
      lastName
    }
    primaryClient {
      id
      firstName
      lastName
    }
  }
`;

export const ADDRESS_FIELDS = gql`
  fragment AddressFields on Address {
    id
    addressId
    partnerId
    primaryClientId
    primaryProjectId
    address1
    address2
    city
    state
    zip
    clientActivatedMembership
    platformSlaId
    clientSelectedMembership
    businessName
    brandId
    ownerId
    orgNotes
    cppExpDate
    creditCardProvided
    chargifySubId
    tosAccepted
    membershipSalesNotes
    rsmNotes
    isMonitored
    createdAt
    updatedAt
    deletedAt

    sitePrimaryEquipmentLocation
    siteNetworkLocation
    siteWiredNetworkBrand
    siteWirelessNetworkBrand
    site3rdPartyNetworkProvider
    siteInternetService

    siteRemoteSystemsManagement
    siteRsmUrl
    siteSecondaryRemoteSystemsManagement
    siteSecondaryRsmUrl
    siteTertiaryRemoteSystemsManagement
    siteTertiaryRsmUrl

    siteTvServiceProvider
    siteControlSystemBrand
    siteShadeType
    siteShadeInterface
    siteShadeBrand
    siteSecuritySystemIntegrated
    siteSecuritySystemBrand
    siteCameraSystemType
    siteCameraSystemBrand
    hvacIntegration
    siteHvacBrand
    siteStreamingPlatform
    siteAccessControlSystemSmartLocks
    siteAudioSystemType
    sitePrimaryAudioInterface
    siteLightingSystemType
    siteLightingSystemBrand
    siteVideoSystemType
    siteVideoDistributionBrand
    siteVideoDoorbell
    sitePhoneSystemType
    sitePhoneSystemBrand
    siteIntercom
  }
`;

const ADDRESS_SUBSCRIPTION_FIELDS = gql`
  fragment AddressSubscriptionFields on AddressSubscription {
    id
    addressSubscriptionId
    stripeSubscriptionId
    partnerId
    addressId
    phase
    status
    createdAt
    updatedAt
    pausedUntil
  }
`;

export const ADDRESS_RELATIONS = gql`
  fragment AddressRelations on Address {
    id
    projects {
      ...ProjectFields
      projectStage {
        id
        name
      }
    }

    brand {
      ...BrandFields
    }

    platformSla {
      id
      platformSlaId
      displayName
    }

    partner {
      ...PartnerFields
      ...PartnerRelations
    }

    primaryClient {
      ...ClientFields
      primaryEmail {
        ...ClientEmailFields
      }
      primaryPhoneNumber {
        ...ClientPhoneFields
      }
    }

    platformUser {
      ...PlatformUserFields
    }

    preSoldMemberships {
      ...PreSoldMembershipFields
    }

    addressSubscriptions {
      ...AddressSubscriptionFields
    }
  }
  ${PROJECT_FIELDS}
  ${BRAND_FIELDS}
  ${PARTNER_FIELDS}
  ${PARTNER_RELATIONS}
  ${CLIENT_FIELDS}
  ${CLIENT_EMAIL_FIELDS}
  ${CLIENT_PHONE_FIELDS}
  ${PLATFORM_FIELDS}
  ${PRE_SOLD_MEMBERSHIP_FIELDS}
  ${ADDRESS_SUBSCRIPTION_FIELDS}
`;

export const ADDRESS_DATA_RESPONSE_FIELDS = gql`
  fragment AddressDataResponseFields on AddressDataResponse {
    records {
      ...AddressFields
      ...AddressRelations
      customAttributes @include(if: $hasCustomAttributes)
    }
    metadata {
      ...MetaDataSearchQueryFields
    }
  }
  ${ADDRESS_FIELDS}
  ${ADDRESS_RELATIONS}
  ${META_DATA_SEARCH_QUERY_FIELDS}
`;
